export const dataHooks = {
  drivenOutChildren: 'driven-out-children',
  onScreenChildrenContainer: 'on-screen-children-container',
  onScreenChildrenContent: 'on-screen-children-content',
  drivenInChildren: 'driven-in-children',
  scrollBarGradient: 'scroll-bar-gradient',
};

export const sidebarSkins = {
  dark: 'dark',
  light: 'light',
};
